<template>
  <legacy-account-camp-coupons
    v-bind="$attrs"
    v-on="$listeners"
  ></legacy-account-camp-coupons>
</template>

<script>
import LegacyAccountCampCoupons from "./CampCoupons.vue";

export default {
  name: "AccountCampCoupons",
  components: {
    LegacyAccountCampCoupons,
  },
};
</script>
